import React from 'react';
import API from '../../services/API';
import CustomStore from 'devextreme/data/custom_store';
import useStyles from '../styles/styles';
import { Column, DataGrid, Paging } from 'devextreme-react/data-grid';
import usePermissions from '../../hooks/usePermissions';
import {
  BreadCrumbRender,
  onToolbarBreadCrumb,
  LoadPermissions,
} from '../../global';
import { Template } from 'devextreme-react/core/template';

const states = new CustomStore({
  key: 'StateId',
  load: async () => {
    const { data } = await API.sendRequest(`State`, 'get');
    return data;
  },
  insert: async (data) => {
    await API.sendRequest(`State`, 'post', data);
  },
  update: async (id, data) => {
    await API.sendRequest(`State`, 'post', data);
  },
  remove: async (id) => {
    await API.sendRequest(`State/${id}`, 'delete');
  },
});

const onRowUpdating = (options) => {
  options.newData = { ...options.oldData, ...options.newData };
};

const State = () => {
  const classes = useStyles();

  /** *******************************
   * Access Control
   ******************************** */
  const ACL = usePermissions();
  while (ACL === undefined) {
    return <LoadPermissions>Loading permissions</LoadPermissions>;
  }
  if (ACL.NoAccess) {
    return (
      <LoadPermissions>You don't have access to this page</LoadPermissions>
    );
  }
  /** ****************************** */

  return (
    <div className={classes.divGridContainer}>
      <DataGrid
        id="gridContainer"
        dataSource={states}
        // keyExpr={'StateId'}
        allowColumnReordering
        showBorders
        rowAlternationEnabled
        focusedRowEnabled
        showRowLines
        onRowUpdating={onRowUpdating}
        headerFilter={{ visible: true }}
        filterPanel={{ visible: true }}
        filterRow={{ visible: true }}
        onToolbarPreparing={onToolbarBreadCrumb}
      >
        <Paging enabled={false} />
        {/* <Editing
          mode={'form'}
          allowAdding={ACL.AddNew}
          allowUpdating={ACL.Update}
          allowDeleting={ACL.Delete}
        /> */}

        <Column dataField="StateCode" caption="Code" />
        <Column dataField="StateName" caption="Name" />
        <Column dataField="StateAbrev" caption="Abrev" />
        <Column dataField="Area" caption="Area" />
        <Column dataField="Population" caption="Population" />
        <Column dataField="Density" caption="Density" />
        <Template name="breadCrumb" render={() => BreadCrumbRender(ACL)} />
      </DataGrid>
    </div>
  );
};

export default State;
